import { GAP_PACKET_ACCESS_DENIED, INVESTIGATOR_BROCHURE_ACCESS_DENIED, READY, RESOURCE_NOT_FOUND } from 'spark-state/common/app/reducer';
// SAF-20237: Import module-specific recipient role checks (Role Assignment - Switch Roles and its Precedence - PSR-4763)
// SAF-20491: Import module-specific support selectors for correct initial routing per support role
import {
    isManagementUser,
    isEnterpriseAdmin,
    isSafetySupport,
    isIBSupport,
    isGapPacketSupport,
    userCurrentEnterprise,
    isGapPacketAdmin,
    isIBManagementUser, //SAF-17154 - importing IBAdmin role check from userReducer
    isSafetyRecipient,
    isGapPacketRecipient,
    isIBRecipient
} from 'spark-state/common/user/userReducer';
import getInitialRedirect from './initialRedirect';

export const NOT_FOUND_ROUTE = '/nosndata';
export const GAP_PACKET_ACCESS_DENIED_ROUTE = '/gapPacketAccessDenied';
export const INVESTIGATOR_BROCHURE_ACCESS_DENIED_ROUTE = '/investigatorBrochureAccessDenied';

const actionHandlers = {
    [READY]: (history, { getState }, action) => {
        const state = getState();
        // SAF-20237: Pass module-specific recipient flags for proper routing (Role Assignment - Switch Roles and its Precedence - PSR-4763)
        // SAF-20491: Pass module-specific support flags so each support role routes to its correct module
        const redirect = getInitialRedirect(history.location.search, {
            enterpriseAdmin: isEnterpriseAdmin(state),
            managementUser: isManagementUser(state),
            isSafetySupport: isSafetySupport(state),
            isIBSupport: isIBSupport(state),
            isGapPacketSupport: isGapPacketSupport(state),
            isGapPacketAdmin: isGapPacketAdmin(state),
            isIBManagementUser: isIBManagementUser(state), //SAF-17154 updating the state with value after IB_Admin & IB Country Lead Role check
            isSafetyRecipient: isSafetyRecipient(state),
            isGapPacketRecipient: isGapPacketRecipient(state),
            isIBRecipient: isIBRecipient(state)
        }, history.location.pathname);
        // Route to nosndata if no enterprise, not enterprise admin, or no valid role
        ((!userCurrentEnterprise(state) && !isEnterpriseAdmin(state)) || !redirect)
            ? history.push(NOT_FOUND_ROUTE)
            : history.replace(redirect);
    },
    [RESOURCE_NOT_FOUND]: history => history.push(NOT_FOUND_ROUTE),
    [GAP_PACKET_ACCESS_DENIED]: history => history.push(GAP_PACKET_ACCESS_DENIED_ROUTE),
    [INVESTIGATOR_BROCHURE_ACCESS_DENIED]: history => history.push(INVESTIGATOR_BROCHURE_ACCESS_DENIED_ROUTE)
};

const navigationMiddleware = history => store => next => action => {
    if (actionHandlers[action.type]) {
        actionHandlers[action.type](history, store, action);
    }
    return next(action);
};

export default navigationMiddleware;
